// extracted by mini-css-extract-plugin
module.exports = {"header":"TheHeader_header_2D92e","isFixed":"TheHeader_isFixed_3IiQv","slideIn":"TheHeader_slideIn_1_Yis"};